import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import InputField from "../../../../components/form/InputField";
import SelectField from "../../../../components/form/SelectField";
import TextAreaField from "../../../../components/form/TextAreaField";
import DateField from "../../../../components/form/DateField";
import FormActionButtons from "../../../../components/Button/FormActionButtons";
import KodeKaryawanInput from "components/form/KodeKaryawanInput";
import { generateKodeKaryawanBaru } from "utils/kodeUtils";
import PasswordPopup from "components/modal/PasswordPopup";
import { jabatan, status, roles } from "mock/dummyOptions";

// helper: ubah string array ke format { id, label }
const toOptions = (array) =>
  array.map((label) => ({
    id: label.toLowerCase().replace(/\s+/g, "-"),
    label,
  }));

const AddKaryawan = () => {
  const navigate = useNavigate();
  const [kodeAngka, setKodeAngka] = useState("");
  const [kodeKaryawan, setKodeKaryawan] = useState("");
  const [kodeList, setKodeList] = useState([]);
  const [lastKode, setLastKode] = useState("");
  const [kodeError, setKodeError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // pakai dummy yang benar
  const jabatanOptions = toOptions(jabatan);
  const jenisPenggunaOptions = toOptions(roles);
  const statusKeanggotaanOptions = toOptions(status);

  useEffect(() => {
    const newPassword = generatePassword();
    setValue("password", newPassword);
    setGeneratedPassword(newPassword);

    const { kodeList, lastKode, kodeAngka, kodeKaryawan } =
      generateKodeKaryawanBaru();

    setKodeList(kodeList);
    setLastKode(lastKode);
    setKodeAngka(kodeAngka);
    setKodeKaryawan(kodeKaryawan);
  }, [setValue]);

  const generatePassword = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };

  const onSubmit = (data) => {
    const existingKaryawan = JSON.parse(localStorage.getItem("karyawan")) || [];

    const emailExists = existingKaryawan.some(
      (karyawan) => karyawan.email === data.email
    );

    if (emailExists) {
      alert("Email sudah terdaftar, pilih email lain.");
      return;
    }

    if (!kodeKaryawan || kodeError) {
      alert("Kode karyawan tidak valid atau sudah digunakan!");
      return;
    }

    const newKaryawan = {
      ...data,
      kode: kodeKaryawan,
    };

    const updatedKaryawan = [newKaryawan, ...existingKaryawan];
    localStorage.setItem("karyawan", JSON.stringify(updatedKaryawan));

    setShowPopup(true);
  };

  const handleCancel = () => {
    navigate("/data-karyawan");
  };

  return (
    <div className="pl-64 mt-8">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="max-w-4xl p-5 mx-auto bg-white border border-gray-200 shadow-lg rounded-2xl"
      >
        <h2 className="mb-5 text-lg font-semibold text-center text-green-700 sm:text-xl">
          Tambah Data Karyawan
        </h2>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {/* Kolom Kiri */}
          <div className="space-y-4">
            <InputField
              label="Nama Lengkap"
              {...register("nama", { required: "Nama wajib diisi" })}
              error={errors.nama}
            />
            <InputField
              label="Email"
              type="email"
              {...register("email", {
                required: "Email wajib diisi",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Format email tidak valid",
                },
              })}
              error={errors.email}
            />
            <SelectField
              label="Jabatan"
              options={jabatanOptions}
              {...register("jabatan", { required: "Jabatan wajib diisi" })}
              error={errors.jabatan}
            />
            <SelectField
              label="Jenis Pengguna"
              options={jenisPenggunaOptions}
              {...register("jenis", { required: "Jenis wajib diisi" })}
              error={errors.jenis}
            />
            <TextAreaField
              label="Alamat"
              {...register("alamat", { required: "Alamat wajib diisi" })}
              error={errors.alamat}
            />
          </div>

          {/* Kolom Kanan */}
          <div className="space-y-4">
            <InputField
              label="No. Telp"
              {...register("telp", { required: "No. Telp wajib diisi" })}
              error={errors.telp}
            />
            <InputField label="Password" readOnly {...register("password")} />
            <SelectField
              label="Status Keanggotaan"
              options={statusKeanggotaanOptions}
              {...register("status", { required: "Status wajib diisi" })}
              error={errors.status}
            />
            <KodeKaryawanInput
              value={kodeAngka}
              onChange={(angka, fullKode, errorMsg) => {
                setKodeAngka(angka);
                setKodeKaryawan(fullKode);
                setKodeError(errorMsg);
              }}
              kodeList={kodeList}
              lastKode={lastKode}
            />
            <DateField
              label="Tanggal Masuk"
              {...register("tanggalMasuk", {
                required: "Tanggal Masuk wajib diisi",
              })}
              error={errors.tanggalMasuk}
            />
          </div>
        </div>

        <FormActionButtons
          submitLabel="Simpan"
          cancelLabel="Batal"
          onCancel={handleCancel}
          fullWidth={true}
        />

        {showPopup && (
          <PasswordPopup
            password={generatedPassword}
            onClose={() => {
              setShowPopup(false);
              navigate("/data-karyawan");
            }}
          />
        )}
      </form>
    </div>
  );
};

export default AddKaryawan;
